import React, { useState, useEffect, useRef } from "react";
type Props = {
  listData: any;
  selectName: any;
  selectedPID: any;
  updateSelectedPIDForParent: Function;
  type: any;
  otherID: any;
  AllowAddNew: boolean;
  KeyUpInputData: Function;
};

export default function SingleSelectSearchableDropdown(props: Props) {
  const [showOptions, setShowOptions] = useState(false);
  const [selectedPID, setSelectedPID] = useState(props.selectedPID);
  const [selectedName, setSelectedName] = useState(props.selectName);
  const componentRef = useRef<any>(null);
  const [currentList, setCurrentList] = useState<any>([]);
  const currentListRef = useRef<any | null>(null);
  const [searchedValue, setSearchedValue] = useState("");

  useEffect(() => {
    setSearchedValue("");
  }, []);

  useEffect(() => {
    setSelectedPID(props.selectedPID);
  }, [props.selectedPID]);

  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (props.listData && props.listData.length > 0) {
      const deepCopy1 = JSON.parse(JSON.stringify(props.listData));
      for (let index = 0; index < deepCopy1.length; index++) {
        if (selectedPID != null && selectedPID != 0) {
          if (selectedPID == deepCopy1[index].PID) {
            deepCopy1[index].IsSelected = true;
            setSelectedName(deepCopy1[index].Name);
            break;
          } else {
            deepCopy1[index].IsSelected = false;
            setSelectedName("");
          }
        } else {
          deepCopy1[index].IsSelected = false; //deepCopy1[index].IsSelected = true;  : ZI
          setSelectedName("");
        }
      }
      setCurrentList(deepCopy1);
      currentListRef.current = deepCopy1;
    }
  }, [props.listData, selectedPID]);

  function sendResponseToParent(selectedUser: any) {
    setShowOptions(false);
    setSearchedValue("");
    setSelectedPID(selectedUser.UserID);
    // setSelectedName(selectedUser.Name);
    props.updateSelectedPIDForParent(
      props.type,
      // selectedIds,
      selectedUser,
      props.otherID,
      ""
    );
  }

  function displayList() {
    setShowOptions(true);
  }

  useEffect(() => {
    if (
      searchedValue !== "" &&
      currentListRef.current &&
      currentListRef.current.length > 0
    ) {
      displayList();
      filterByKeyUp();
    } else {
      setCurrentList(currentListRef.current);
    }
  }, [searchedValue]);

  function filterByKeyUp() {
    let filterArray: any = [];
    filterArray = filterByValue(currentListRef.current, searchedValue);
    setCurrentList(filterArray);
  }

  function filterByValue(array: any, value: string) {
    return array.filter(
      (data: any) =>
        data.Name && data.Name.toLowerCase().includes(value.toLowerCase())
    );
  }
  const [focusedIndex, setFocusedIndex] = useState(-1); // State to track the focused item

  function handleKeyDown(event: React.KeyboardEvent) {
    if (showOptions && currentList && currentList.length > 0) {
      if (event.key === "ArrowDown") {
        setFocusedIndex((prev) =>
          prev < currentList.length - 1 ? prev + 1 : 0
        );
      } else if (event.key === "ArrowUp") {
        setFocusedIndex((prev) =>
          prev > 0 ? prev - 1 : currentList.length - 1
        );
      } else if (event.key === "Enter" && focusedIndex >= 0) {
        sendResponseToParent(currentList[focusedIndex].PID);
        // setSelectedName(currentList[focusedIndex].Name);
        setFocusedIndex(-1); // Reset focus index
      }
    }
  }

  return (
    <>
      <div className="multi-select p-relative" ref={componentRef}>
        <a className="multi-ps flex-da flex-jse p-relative">
          <input
            value={searchedValue}
            onChange={(e: any) => {setSearchedValue(e.target.value);props.KeyUpInputData(e.target.value)}}
            placeholder={selectedName}
            onClick={() => displayList()}
            onKeyDown={handleKeyDown}
          />
          <img
            src="/images/icon-search.svg"
            width="15"
            height="15"
            alt="search"
          />
        </a>
        <div className={showOptions ? "multi-drop" : "multi-drop no-display"}>
          {currentList &&
            currentList.map((item: any, index: any) => (
              <React.Fragment key={index}>
                <a onClick={() => sendResponseToParent(item)}>
                  <div
                    className={`multi-item flex-d flex-ac flex-gap5  ${
                      focusedIndex === index ? "focused-item" : ""
                    }`}
                  >
                    <span>{item.Name}</span>
                  </div>
                </a>
              </React.Fragment>
            ))}
        </div>
        {props.AllowAddNew == true && searchedValue !== "" && (
          <div className="help-btns mt--0">
            <a
              onClick={() => {
                props.updateSelectedPIDForParent(
                  props.type,
                  "",
                  props.otherID,
                  searchedValue
                );
                setSearchedValue("");
              }}
            >
              Add
            </a>
          </div>
        )}
      </div>
    </>
  );
}
